import { render, staticRenderFns } from "./CrawlForm.vue?vue&type=template&id=6b01bae1&scoped=true&"
import script from "./CrawlForm.vue?vue&type=script&lang=js&"
export * from "./CrawlForm.vue?vue&type=script&lang=js&"
import style0 from "./CrawlForm.vue?vue&type=style&index=0&id=6b01bae1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b01bae1",
  null
  
)

export default component.exports